module.exports = __webpack_public_path__ + "img/faq.aa74427e.svg";